import Diagnosis from "../../../../models/patient-chart/diagnosis";

export interface DiagnosisData {
  primary: Diagnosis;
  secondary: Diagnosis;
  related: Array<Diagnosis>;
  unrelated?: Array<Diagnosis>;
  visit?: Array<Diagnosis>;
}

export const PRIMARY = "primary";
export const SECONDARY = "secondary";
export const RELATED = "related";
export const UNRELATED = "unrelated";
export const VISIT = "visit";



// WEBPACK FOOTER //
// ./src/pages/patient-chart/diagnosis/models/diagnosis-data.ts